import type {
  PageSettingsSchema,
  SettingResponse,
} from '@/entities/system/setting';
import { type AxiosRequestConfig } from 'axios';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

export class SRMSettingsApi {
  static getAllSettings(params = {}, options?: AxiosRequestConfig) {
    return srmInstance.get<PageSettingsSchema>(`/settings`, {
      ...options,
      params,
    });
  }
  static editSetting(
    setting_id: string,
    payload: { value: string },
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.put<SettingResponse>(
      `/settings/${setting_id}`,
      payload,
      options,
    );
  }
}